export function onlyNumbers(e) {
  const theEvent = e || window.event
  let key = theEvent.keyCode || theEvent.which
  key = String.fromCharCode(key)
  const regex = /^[0-9.]+$/
  if (!regex.test(key)) {
    theEvent.returnValue = false
    if (theEvent.preventDefault) theEvent.preventDefault()
  }
}

export function onlyNumbersByDecimalPlaces(e, decimalPlaces) {
  const theEvent = e || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);

  // Impede a digitação de ponto (.)
  if (key === '.') {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
    return;
  }

  // Regex para permitir apenas números e vírgulas
  const regex = /^[0-9,]+$/;

  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
    return;
  }

  // Pega o valor atual do input
  const input = e.target.value;

  // Verifica se já existe uma vírgula no valor atual
  const decimalIndex = input.indexOf(',');
  if (decimalIndex !== -1) {
    // Se já existe uma vírgula e o usuário tenta digitar outra vírgula
    if (key === ',') {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
      return;
    }

    // Verifica o número de casas decimais permitido
    const decimals = input.substring(decimalIndex + 1);
    if (decimals.length >= decimalPlaces) {
      // Se já atingiu o limite de casas decimais, bloqueia a entrada de mais números
      if (/[0-9]/.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
}




export function extractNumber(str) {
  const numbers = str.replace(/\D/g, '');
  return numbers.length > 0 ? parseInt(numbers, 10) : 0;
}

export const returnOnlyNumbers = (value) => {
  const numberPattern = /\d+/g;
  return value.match(numberPattern).join([]);
};